<template>
  <div class="integralExchange">
    <!-- 编辑蒙版 -->
    <el-dialog
      title=""
      :visible.sync="editMask"
      width="1190px"
      :before-close="handleClose2">
      <div class="addArea" v-if="editInfo">
        <h2 class="addTitle">编辑收货地址</h2>
        <div class="addInfo">
          <div class="addInfo1 addli">
            <p>* 地址信息</p>
            <el-select
              :placeholder="editInfo.province"
              @change="handleProvinceChoose"
              v-model="selectProvince"
              style="margin-right: 20px;"
            >
              <el-option
                v-for="(item, index) in provinceList"
                :key="index"
                :label="item.name"
                :value="`${item.name}%${item.codeP}`">
              </el-option>
            </el-select>
            <el-select
              :disabled="selectProvince?false:true"
              v-model="selectCity"
              :placeholder="editInfo.city"
              @change="handleCityChoose"
              style="margin-right: 20px;"
            >
              <el-option
                v-for="(item, index) in cityList"
                :key="index"
                :label="item.name"
                :value="`${item.name}%${item.codeC}`">
              </el-option>
            </el-select>
            <el-select
              :disabled="selectCity?false:true"
              v-model="selectArea"
              :placeholder="editInfo.area"
              @change="handleAreaChoose"
            >
              <el-option
                v-for="(item, index) in areaList"
                :key="index"
                :label="item.name"
                :value="`${item.name}%${item.codeA}`">
              </el-option>
            </el-select>
          </div>
          <div class="addInfo2 addli">
            <p>* 详细地址</p>
            <input v-model.trim="reciveAddress" type="text" placeholder="请输入详细地址信息">
          </div>
          <div class="addInfo3 addli">
            <p>* 收货人姓名</p>
            <input v-model.trim="reciveName" type="text" placeholder="请输入收货人姓名">
          </div>
          <div class="addInfo4 addli">
            <p>* 手机号码</p>
            <input v-model.number="recivePhone" type="text" placeholder="请输入手机号码">
            <div style="width: 516px"></div>
            <el-checkbox
              v-model="defaulted"
              text-color="#333333"
              fill="#1D65A8"
              class="defaultbox"
            >
              设为默认收货地址
            </el-checkbox>
          </div>
        </div>
        <div @click="handleSaved" class="saveAdd">保存地址</div>
      </div>
    </el-dialog>
    <!-- 删除提示蒙版 -->
    <el-dialog
      title=""
      :visible.sync="deleteMask"
      width="30%"
      :before-close="handleClose">
      <span>{{$t('message.deleteAddress')}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelAddDelete">{{$t('cancel')}}</el-button>
        <el-button type="primary" @click="confirmAddDelete">{{$t('confirm')}}</el-button>
      </span>
    </el-dialog>
    <!-- 删除提示蒙版结束 -->
    <div class="addressManagement">
      <div class="addTitle">
        <div class="addTitle1">收货地址管理:</div>
        <div class="addTitle2" @click="jumpAddAddress"><i>+</i> 新增地址</div>
      </div>
      <ul v-if="addressList" class="addList">
        <li
          v-for="(item, index) in addressList"
          :key="index"
        >
          <div class="addListInfo">
            <div class="addListInfo1">{{item.receiveGoodsPerson}} {{item.receiveGoodsPhone}}<span v-if="item.defaultAddress">默认</span></div>
            <div class="addListInfo2">
              <div><span class="addListInfo22"></span> {{item.province}}-{{item.city}}-{{item.area}}-{{item.address}}</div>
            </div>
          </div>
          <div class="addListFunction">
            <div class="editIcon"><i @click="handleEdit(item)" class="el-icon-edit-outline"></i></div>
            <div class="deleteIcon"><i @click="handleAddDelete(item.userAddressId)" class="el-icon-delete"></i></div>
          </div>
        </li>
      </ul>
    </div>
    <div v-if="addressList" class="doclist-pagination">
      <div class="doclist-lastpage" @click="jumpLastPage">上一页</div>
      <div class="doclist-omit">{{lastOmit}}</div>
      <ul>
        <li :class="item === currentPage?'pageactive':'pageDeavtive'" v-for="(item, index) in pageList" :key="index" @click="changePageTo(item)">{{item}}</li>
      </ul>
      <div class="doclist-omit">{{nextOmit}}</div>
      <div class="doclist-nextpage" @click="jumpNextPage">下一页</div>
      <div class="doclist-pagejump">共{{totalPage}}页，到第<input type="text" v-model.number="jumpTargetPage">页</div>
      <div class="doclist-jump" @click="jumpFarPage">确定</div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      addressList: null,
      deleteMask: false,
      deleteId: null,
      editMask: false,
      editInfo: null,
      // 分页
      currentPage: 1, // 当前页
      totalPage: 4, // 总页数
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1, // 跳转页
      //
      defaulted: false,
      recivePhone: '',
      reciveName: '',
      reciveAddress: '',
      provinceList: null,
      selectProvince: '',
      cityList: null,
      selectCity: '',
      areaList: null,
      selectArea: '',
      province: '',
      city: '',
      area: '',
      codeP: '',
      codeC: '',
      codeA: ''
    }
  },
  methods: {
    handleEdit (item) {
      this.editMask = true
      this.editInfo = item
      this.reciveAddress = item.address
      this.reciveName = item.receiveGoodsPerson
      this.recivePhone = item.receiveGoodsPhone
      this.defaulted = item.defaultAddress
    },
    jumpAddAddress () {
      sessionStorage.setItem('addOrderMounted', JSON.stringify(777))
      this.$router.push({ name: 'integralAddressAdd' })
    },
    cancelAddDelete () {
      this.deleteMask = false
      this.deleteId = null
    },
    confirmAddDelete () {
      // let deleteIdList = []
      // deleteIdList.push(this.deleteId)
      this.$http.post(`/front/consumer/user/address/deleteById/${this.deleteId}`)
        .then(({ data }) => {
          if (data.code === 0) {
            this.$message.success('地址删除成功')
            this.getAddressList()
            this.handleClose()
            this.$emit('childByValue', '222')
          } else {
            // this.$message.error(data.result.msg)
            this.$emit('childByValue', '222')
          }
        })
        .catch(() => {
          // this.$message.error(error.response.data.message)
        })
    },
    handleAddDelete (id) {
      this.deleteMask = true
      this.deleteId = id
    },
    handleClose () {
      this.deleteMask = false
      this.deleteId = null
    },
    handleClose2 () {
      this.editMask = false
      this.editInfo = null
      this.selectProvince = ''
      this.cityList = null
      this.selectCity = ''
      this.areaList = null
      this.selectArea = ''
      this.province = ''
      this.city = ''
      this.area = ''
      this.codeP = ''
      this.codeC = ''
      this.codeA = ''
    },
    handleSaved () {
      const reg = /^((13[0-9])|(14[5,7,9])|(15[^4])|(18[0-9])|(17[0,1,2,3,5,6,7,8])|(19[8,9]))\d{8}$/
      if (this.reciveAddress === '') {
        this.$message.warning('请输入详细地址信息')
      } else if (this.reciveName === '') {
        this.$message.warning('请输入正确的收货人姓名')
      } else if (this.recivePhone === '') {
        this.$message.warning('手机号码不能为空')
      } else if (!reg.test(this.recivePhone)) {
        this.$message.warning('请输入有效的手机号码')
      } else if (this.reciveAddress.toString().length > 50) {
        this.$message.warning('输入地址长度不能超过50位')
      } else if (this.reciveName.toString().length > 20) {
        this.$message.warning('输入姓名长度不能超过20位')
      } else {
        if (this.codeA === '') {
          this.$http.post(`/front/consumer/user/address/updateUserAddress`, {
            userAddressId: this.editInfo.userAddressId,
            address: this.reciveAddress,
            defaultAddress: this.defaulted,
            receiveGoodsPerson: this.reciveName,
            receiveGoodsPhone: this.recivePhone
          })
            .then(({ data }) => {
              if (data.code === 0) {
                this.$message.success('地址更新成功')
                this.handleClose2()
                this.getAddressList()
                this.$emit('childByValue', '333')
              } else {
                // this.$message.error(data.result.msg)
                this.handleClose2()
                this.getAddressList()
                this.$emit('childByValue', '222')
              }
            })
            .catch(() => {
              // this.$message.error(error.response.data.message)
              this.handleClose2()
              this.getAddressList()
            })
        } else {
          this.$http.post(`/front/consumer/user/address/updateUserAddress`, {
            userAddressId: this.editInfo.userAddressId,
            address: this.reciveAddress,
            defaultAddress: this.defaulted,
            receiveGoodsPerson: this.reciveName,
            province: this.province,
            city: this.city,
            area: this.area,
            receiveGoodsPhone: this.recivePhone
          })
            .then(({ data }) => {
              if (data.code === 0) {
                this.$message.success('地址更新成功')
                this.handleClose2()
                this.getAddressList()
                this.$emit('childByValue', '333')
              } else {
                // this.$message.error(data.result.msg)
                this.handleClose2()
                this.getAddressList()
              }
            })
            .catch(() => {
              // this.$message.error(error.response.data.message)
              this.handleClose2()
              this.getAddressList()
              this.$emit('childByValue', '222')
            })
        }
      }
    },
    handleProvinceChoose (value) {
      this.$forceUpdate()
      this.province = this.selectProvince.slice(0, this.selectProvince.indexOf('%'))
      this.codeP = this.selectProvince.slice(this.selectProvince.indexOf('%') + 1)
      this.selectCity = ''
      this.cityList = null
      this.selectArea = ''
      this.areaList = null
      this.area = ''
      this.city = ''
      this.codeC = ''
      this.codeA = ''
      this.getCity()
      // console.log(this.codeP)
    },
    handleCityChoose (value) {
      this.city = this.selectCity.slice(0, this.selectCity.indexOf('%'))
      this.codeC = this.selectCity.slice(this.selectCity.indexOf('%') + 1)
      this.selectArea = ''
      this.areaList = null
      this.area = ''
      this.codeA = ''
      this.getArea()
    },
    handleAreaChoose (value) {
      this.area = this.selectArea.slice(0, this.selectArea.indexOf('%'))
      this.codeA = this.selectArea.slice(this.selectArea.indexOf('%') + 1)
    },
    jumpToMy () {
      this.$router.push({ name: 'basicInfo' })
    },
    jumpToIntegralManagement () {
      this.$router.push({ name: 'integralManagment' })
    },
    jumpToExchangeAddress () {
      this.$router.push({ name: 'integralAddress' })
    },
    getProvince () {
      this.$request.get(`/front/sys/sysProvince/provinceList`)
        .then(data => {
          // if (data.result.code === 0) {
          this.provinceList = data || []
          // } else {
          //   this.$message.error(data.result.msg)
          // }
        })
      // .catch(error => {
      //   this.$message.error(error.response.data.message)
      // })
    },
    getCity () {
      this.$request.get(`/front/sys/sysProvince/cityList/${this.codeP}`)
        .then(data => {
          // if (data.result.code === 0) {
          this.cityList = data || []
          // } else {
          //   this.$message.error(data.result.msg)
          // }
        })
        // .catch(error => {
        //   this.$message.error(error.response.data.message)
        // })
    },
    getArea () {
      this.areaList = []
      this.$request.get(`/front/sys/sysProvince/areaList/${this.codeC}`)
        .then(data => {
          // if (data.result.code === 0) {
          this.areaList = data || []
          // } else {
          //   this.$message.error(data.result.msg)
          // }
        })
    },
    // 上一页
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    //  下一页
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    //   第几页
    changePageTo (page) {
      window.scrollTo(0, 0)
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [this.totalPage - 4, this.totalPage - 3, this.totalPage - 2, this.totalPage - 1, this.totalPage]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
      this.getAddressList()
    },
    //   确定跳转到哪页
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        if (this.totalPage > 5) {
          if (this.jumpTargetPage > 2 && this.jumpTargetPage < this.totalPage - 4) {
            var newPageList3 = []
            for (let index = this.jumpTargetPage - 2; index < this.jumpTargetPage + 3; index++) {
              newPageList3.push(index)
            }
            this.pageList = newPageList3
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = '...'
          } else if (this.jumpTargetPage <= 2) {
            this.pageList = [1, 2, 3, 4, 5]
            this.currentPage = this.jumpTargetPage
            this.lastOmit = ''
            if (this.jumpTargetPage > this.totalPage - 3) {
              this.nextOmit = ''
            } else {
              this.nextOmit = '...'
            }
          } else {
            var newPageList4 = [this.totalPage - 4, this.totalPage - 3, this.totalPage - 2, this.totalPage - 1, this.totalPage]
            this.pageList = newPageList4
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = ''
          }
        } else {
          var newPageList5 = []
          for (let index = 1; index <= this.totalPage; index++) {
            newPageList5.push(index)
          }
          this.pageList = newPageList5
          this.lastOmit = ''
          this.nextOmit = ''
          this.currentPage = this.jumpTargetPage
        }
        this.getAddressList()
        window.scrollTo(0, 0)
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    getAddressList () {
      this.$request.postParam(`/front/consumer/user/address/selectUserAddressList`, {
        page: this.currentPage,
        limit: 10
      })
        .then(data => {
          this.addressList = data.data || []
          this.totalPage = Math.ceil(data.count / 10)
          let newPageList = []
          if (this.totalPage <= 5) {
            for (let i = 1; i <= this.totalPage; i++) {
              newPageList.push(i)
            }
            this.pageList = newPageList
            this.nextOmit = ''
          }
        })
        // .catch(error => {
        //   this.$message.error(error.response.data.message)
        // })
    }
  },
  created () {
    this.getAddressList()
    this.getProvince()
  }
}
</script>

<style scoped>
.integralExchange{
  width: 1190px;
  background: #ffffff;
  padding-bottom: 30px;
  padding-top: 20px;
  padding-left: 30px;
  padding-right: 40px;
}
.addTitle{
  height: 40px;
  display: flex;
}
.addTitle1{
  flex: 1;
  font-size: 16px;
  color: #666666;
  line-height: 44px;
}
.addTitle2{
  width: 130px;
  height: 40px;
  box-sizing: border-box;
  border: 1px solid #1d65A8;
  color: #1D65A8;
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  user-select: none;
  cursor: pointer;
  z-index: 666;
}
.addList{
  margin-bottom: 30px;
}
.addList li{
  height: 98px;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  user-select: none;
}
.addListInfo{
  flex: 1;
  padding-top: 23px;
  padding-bottom: 23px;
}
.addListInfo1{
  height: 16px;
  line-height: 16px;
  font-size: 16px;
  color: #333333;
  font-weight: bold;
  margin-bottom: 18px;
}
.addListInfo1 span{
  display: inline-block;
  width: 35px;
  height: 20px;
  line-height: 20px;
  background: #1D65A8;
  color: #ffffff;
  font-weight: normal;
  font-size: 12px;
  text-align: center;
  margin-left: 20px;
  transform: scale(0.8) translateY(-2px)
}
.addListInfo2{
  font-size: 14px;
  height: 18px;
  line-height: 18px;
  color: #333333;
}
.addListInfo22{
  display: inline-block;
  vertical-align: middle;
  width: 14px;
  height: 18px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAkCAIAAAAVRs0DAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NkZDMDVERTlCMzM0MTFFOUE2NEE4RTBDODdDMEZGNjkiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NkZDMDVERUFCMzM0MTFFOUE2NEE4RTBDODdDMEZGNjkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2RkMwNURFN0IzMzQxMUU5QTY0QThFMEM4N0MwRkY2OSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo2RkMwNURFOEIzMzQxMUU5QTY0QThFMEM4N0MwRkY2OSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PtcxVVMAAAUNSURBVHjanJb7L9ZvGMc9H2qOlVNZlGNoTE4zoi2L5bBZDjkvP1hCfjb+A2XqB5ZZlmbGatNyWCc2Go0fGEXMIYQKiS8ih8n3pdue76fnIH2v7bmfe/fhfV/Xdb/f1/1R7Ozs6Gixz58/9/T0DA8P//PLFArF0aNHTU1NXV1dvby8Tpw4oW2jQiPowMBAbW3t9PS0jnazs7OLi4s7c+bMn0FXVlYePnzY399PX1dXF6c8PDyOHz9+7NgxVuLv7Ozs27dvcf/nz5+sweVr164ZGhpqBf3y5UtxcfG3b9+Au3jxYmRkpJGRkUY3l5eXGxoa2tvbgbayssrJybG0tNQACuKtW7d+/PhBsrKzs1mq8yebnJwsLS1dWFgwMTHJz883NzcX45L4A4tpWicnp7y8vIMgYqdPnwaLlqTdu3dvc3PzN9CqqiqSRQg3b95USRC2urr68eNH/FpbW1OZOnLkCLHDCm718ePHYlCPHxu6urrIY1ZWlgpiX1/f8+fPx8bGRJYkSeK6ybWLi4tyDYg3btwoLCx88+ZNSEgIUe56+vTpU9qgoCBra2vlUm4A90tKSj58+ADi4cOHDx06xODQ0NCdO3cgnPxsR0dHX19fZuvr63c9hSWwEjc5X76OWNra2ugEBgZeunTp5MmTQH/69OnFixeE9erVK86IiopSrqfPeG9vLxcjvXv3jiFnZ2eiUK6Ahi0tLXTS09OhIREgJ2I/derU9evXExMTmXr27JlcHXCZG9ve3obj0vv37xmC4XI3ySNtQECAn5+f+qUHBwezHsfxWj4uQACUoLogh3IOZpA4OhEREdrIFB4eTotTcu0IEAClpaUlcYPKOUaJQl9fn4i0gZIHskH6kJacBrQA7k7QMzAwkHtKq85WuXFL8EG5WJgA2b0oKoXwTjknRhAfnNcG+vXr1/X1dZxVCVFsl0SMcEUehZApxVQbqJii+gl/hQkyACi5u7vTg2LyPQiB9smTJyLj6m5SouhcuHBBPt7d3U0LoOTt7Q0HBwcH5SmHNLCd8G/fvj06OirfCWNQJKm0t7eHc8rxubm58fFxRHTu3Dk9UnD27FlE1dzcHBMTs1cR9PSoA3fv3p2fny8qKoIrtra2qHBiYmJqaooFlMfMzEy8UYK+fPlS1GxueFf7YWFhtK2trd+/f5crhBpIHALr9evXqBZEgPz9/ZkS9ymMW+3o6KBz+fLlvSpFySEWnEd58fHxKuWHkoiUcRk4TkI2FhYWKlmuq6uD2m5ubnsi2vllIyMjGRkZhMwLuvOXRhnjbLJBHGJkr0hT8KldnFZTU6PzNwYEW2gpZjY2Nr9Vfiw2NhZponrSd3BQSg8vgrGx8ZUrV5SD/4GamZldvXqVDgUYJh4EEbY3NjbSSU5OBlcDqOA8yd7Y2ODp3+fLRRi5evDgAS158/HxkU9JKkspydQFCN/U1LQ/KC8H4ubhw02VKVVQ2JeQkCD27PPZw6m8KHRSU1PVPzgk9Q2Iz9PTc2tr6/79+6RCfQHyLS8vRxTnz59HlOoLJI2OpKWlcW8zMzPV1dXqsxUVFYuLi1SypKQkjds1g6JfHjiqQ2dnp3hTlca7xMcARRqxyOven0ExBweH6OhoOo8ePYKJYhDhoUg6+Cj/SDgoKBYaGiqSW1ZWhgT5TiHLIpXoZ5+Niv35yINTUFBAcuVPZm5uLuH/f1Bx15WVlRRcqhR3nZKSgpr33/KvAAMAKjHbdhVX7QEAAAAASUVORK5CYII=) no-repeat;
  background-size: 14px 18px;
  margin: 0 14px 0 0;
}
.addListFunction{
  width: 116px;
  display: flex;
}
.editIcon{
  width: 58px;
}
.editIcon i{
  display: block;
  width: 14px;
  height: 14px;
  margin: auto;
  margin-top: 40px;
  transform: scale(1.5);
  user-select: none;
  cursor: pointer;
}
.deleteIcon{
  width: 58px;
}
.deleteIcon i{
  display: block;
  width: 14px;
  height: 14px;
  margin: auto;
  margin-top: 40px;
  transform: scale(1.5);
  user-select: none;
  cursor: pointer;
}
/* 分页区域样式 */
.doclist-pagination .pageactive{
  background: #1D65A8;
  color: #ffffff;
  border: 0;
}
.doclist-pagination{
  margin-top: 30px;
  display: flex;
  height: 40px;
  line-height: 40px;
  text-align: center;
  /* padding-left: 245px; */
}
.doclist-pagination ul{
  display: flex;
}
.doclist-pagination ul li{
  width: 40px;
  height: 40px;
  font-size: 14px;
  color: #999999;
  line-height: 40px;
  text-align: center;
  user-select: none;
  cursor: pointer;
  border: 1px solid #eeeeee;
}
.doclist-omit{
  width: 40px;
  height: 40px;
  font-size: 14px;
  color: #999999;
  line-height: 40px;
  text-align: center;
  user-select: none;
}
.doclist-lastpage{
  font-size: 14px;
  color: #666666;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  padding: 0 26px;
}
.doclist-nextpage{
  font-size: 12px;
  color: #666666;
  margin-right: 34px;
  margin-left: 18px;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  padding: 0 26px;
}
.doclist-pagejump{
  height: 40px;
  color: #999999;
  font-size: 14px;
  margin-right: 46px;
}
.doclist-pagejump input{
  width: 35px;
  height: 40px;
  box-sizing: border-box;
  margin-left: 14px;
  margin-right: 8px;
  width: 34px;
  border: 1px solid #e4e4e4;
  text-align: center;
}
.doclist-jump{
  color: #666666;
  font-size: 14px;
  user-select: none;
  cursor: pointer;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  padding: 0 26px;
}
.doclist-lastpage{
  user-select: none;
  cursor: pointer;
}
.doclist-nextpage{
  user-select: none;
  cursor: pointer;
}
.pageDeavtive{
  box-sizing: border-box;
  border: 1px solid #eeeeee;
}
/* 分页区域样式结束 */
.addAddress{
  width: 1100px;
  margin: 0 auto;
}
.addArea{
  width: 1100px;
  height: 506px;
  background: #ffffff;
  padding-left: 23px;
  padding-right: 42px;
}
.addTitle{
  height: 80px;
  line-height: 80px;
  font-size: 22px;
  color: #333333;
  text-indent: 8px;
  border-bottom: 1px solid #eeeeee;
}
.addInfo{
  height: 309px;
  padding: 40px 0;
  border-bottom: 1px solid #eeeeee;
}
.addInfo p {
  margin: 0;
}
.addli{
  height: 36px;
  line-height: 36px;
  display: flex;
  margin-bottom: 30px;
  color: #333333;
  font-size: 14px;
}
.addli p{
  width: 198px;
  margin: 0;
}
.addli input{
  padding-left: 10px;
}
.addInfo1 p{
  text-indent: 98px;
}
.addInfo2 p{
  text-indent: 98px;
}
.addInfo3 p{
  text-indent: 84px;
}
.addInfo4 p{
  text-indent: 98px;
}
.addInfo1 input{
  width: 436px;
}
.addInfo2 input{
  width: 811px;
}
.addInfo3 input{
  width: 160px;
}
.addInfo4 input{
  width: 160px;
}
.default{
  text-indent: 21px;
}
.saveAdd{
  width: 150px;
  height: 40px;
  background: #1D65A8;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  margin-top: 30px;
  margin-left: 859px;
  cursor: pointer;
  user-select: none;
}
</style>
